// /home/clement/compta-app/client/src/api/tempsProjetApi.js

import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

export const fetchTempsProjet = async (projetId) => {
  const response = await axios.get(`${API_URL}/projets/${projetId}/temps`);
  return response.data;
};

